import { render, staticRenderFns } from "./Annotator.vue?vue&type=template&id=199ef9a0&scoped=true&"
import script from "./Annotator.vue?vue&type=script&lang=js&"
export * from "./Annotator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ef9a0",
  null
  
)

export default component.exports